module.exports = __webpack_public_path__ + "img/Navigation.fcbe6749.svg";